/**
 * Asset Attribute
 **/
import {AssetAttributeApiDto} from "../../api/model/rest";

export default class AssetAttribute {
	constructor(readonly header: string,
		readonly label: string) {}

	static fromJson(json: AssetAttributeApiDto): AssetAttribute {
		return new AssetAttribute(json.header, json.label);
	}
}